'use client';

import { useRouter } from 'next/router';
import { useCallback, useMemo } from 'react';

type UseFormBuilderQueryParamsReturn = {
  searchParams: URLSearchParams;
  pushQueryParams: (params: URLSearchParams) => void;
};

// Pages Router stand-in for next/navigation's useSearchParams plus a query-only push.
export function useFormBuilderQueryParams(): UseFormBuilderQueryParamsReturn {
  const router = useRouter();

  const searchParams = useMemo(
    () => new URLSearchParams(router.asPath.split('?')[1] ?? ''),
    [router.asPath]
  );

  const pushQueryParams = useCallback(
    (params: URLSearchParams) => {
      const pathname = router.asPath.split('?')[0];
      router.push(`${pathname}?${params.toString()}`, undefined, {
        scroll: false,
      });
    },
    [router]
  );

  return { searchParams, pushQueryParams };
}
